<div class="row mb-3">

  <div class="col-3">
    <div class="value-name">
      HIT Created
    </div>
    <div>
      {{ mostRecentTask?.createdAt | date: 'MM/dd/yyyy' | blankValueDash }}
    </div>
  </div>

  <div class="col-3">
    <div class="value-name">
      MT HIT ID
    </div>
    <div>
      {{ mostRecentTask?.externalIdentifier | blankValueDash }}
    </div>
  </div>

  <div class="col-3">
    <div class="value-name">
      CMS Specialties
    </div>
    <div>
      {{ informationCollectionDetails?.cmsSpecialties?.join(', ') | blankValueDash }}
    </div>
  </div>

</div>

<div class="row">

  <div class="col-3">
    <div class="value-name">
      HIT Completed
    </div>
    <div>
      {{ mostRecentAnswer?.createdAt | date: 'MM/dd/yyyy' | blankValueDash }}
    </div>
  </div>

  <div class="col-3">
    <div class="value-name">
      MT Worker ID
    </div>
    <div>
      {{ mostRecentAnswer?.workerIdentifier | blankValueDash }}
    </div>
  </div>

  <div class="col-3">
    <div class="value-name">
      HIT Source Websites
    </div>
    <div>
      @for (website of taskResultSourceWebsites; track website) {
        <div>
          @if (website.shouldLink) {
            <span>
              <a href="{{ website.url }}"
                target="_blank"
                (click)="confirmExternalLink(website.url)">
                {{ website.url }}
              </a>
            </span>
          }
          @if (!website.shouldLink) {
            <span>
              {{ website.url }}
            </span>
          }
        </div>
      }

      @if (taskResultSourceWebsites.length === 0) {
        <app-blank-value-dash />
      }
    </div>
  </div>

  <div class="col-3">
    <div class="value-name">
      HIT Details
    </div>
    <div>
      {{ taskResultIssues | blankValueDash }}
    </div>
  </div>

</div>
